import React from "react";

export default function ResetIcon({ size = 17, color = "#79808A" }: { size?: number, color?: string }) {
    return (
        <svg width={size} height={size - 1} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.28853 12.7167C4.9069 13.3367 5.6417 13.8283 6.4507 14.1634C7.2597 14.4985 8.12695 14.6704 9.0026 14.6693C12.6845 14.6693 15.6693 11.6845 15.6693 8.0026C15.6693 4.32075 12.6845 1.33594 9.0026 1.33594C7.16186 1.33594 5.4952 2.08223 4.28853 3.28853C3.67446 3.9026 2.33594 5.41001 2.33594 5.41001" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M1.5 2.58594V5.91927H4.83333" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}